import { useApp } from "@lib/providers";
import React from "react";
import { RadioChannelNameContainer } from "./styles";
import { ChannelHighlightSquare } from "./styles";
import { RadioChannelName } from "./styles";

export const ChannelHeader = () => {
  const { darkMode } = useApp();
  return (
    <RadioChannelNameContainer darkMode={darkMode}>
      {/* <ChannelHighlightSquare /> */}
      <RadioChannelName>SRC Dispatch</RadioChannelName>
    </RadioChannelNameContainer>
  );
};
